import type { CSSProperties } from 'react'

type SocialProviderIconProps = {
  size?: number
  className?: string
  style?: CSSProperties
}

export const GoogleBrandIcon = ({
  size = 18,
  className,
  style
}: SocialProviderIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    style={style}
  >
    <path
      d="M17.64 9.20455C17.64 8.56818 17.5827 7.95455 17.4764 7.36364H9V10.8455H13.8436C13.635 11.9709 13.0009 12.9255 12.0464 13.5618V15.8182H14.9523C16.6559 14.25 17.64 11.9364 17.64 9.20455Z"
      fill="#4285F4"
    />
    <path
      d="M9 18C11.43 18 13.4673 17.1941 14.9523 15.8182L12.0464 13.5618C11.2405 14.1018 10.2095 14.4205 9 14.4205C6.65591 14.4205 4.67227 12.8373 3.96409 10.71H0.959091V13.04C2.43682 15.975 5.47409 18 9 18Z"
      fill="#34A853"
    />
    <path
      d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.96H0.959091C0.347727 6.17727 0 7.55182 0 9C0 10.4482 0.347727 11.8227 0.959091 13.04L3.96409 10.71Z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.57955C10.3193 3.57955 11.5036 4.03364 12.4345 4.92545L15.0177 2.34227C13.4632 0.894545 11.4259 0 9 0C5.47409 0 2.43682 2.025 0.959091 4.96L3.96409 7.29C4.67227 5.16273 6.65591 3.57955 9 3.57955Z"
      fill="#EA4335"
    />
  </svg>
)

export const MicrosoftBrandIcon = ({
  size = 18,
  className,
  style
}: SocialProviderIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    style={style}
  >
    <rect width="8" height="8" x="1" y="1" fill="#F35325" />
    <rect width="8" height="8" x="9" y="1" fill="#81BC06" />
    <rect width="8" height="8" x="1" y="9" fill="#05A6F0" />
    <rect width="8" height="8" x="9" y="9" fill="#FFBA08" />
  </svg>
)

export const AppleBrandIcon = ({
  size = 18,
  className,
  style
}: SocialProviderIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    style={style}
  >
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
  </svg>
)

export const FingerprintIcon = ({
  size = 18,
  className,
  style
}: SocialProviderIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    style={style}
  >
    <path d="M12 11c0 7-2 10-2 10" />
    <path d="M14 13.5C14 17 13 21 13 21" />
    <path d="M8 15c0 5-2 6-2 6" />
    <path d="M5.5 13c0-3 .5-4.5.5-4.5" />
    <path d="M18 18c.4-2.4.5-3.5.5-6 0-3.6-2.91-6.5-6.5-6.5s-6.5 2.9-6.5 6.5c0 .9 0 1.7.1 2.5" />
    <path d="M21 12.5c0-4.7-3.8-8.5-8.5-8.5-1.6 0-3.1.4-4.4 1.2" />
    <path d="M16 12c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 .8 0 1.4-.1 2.1" />
    <path d="M18 21c-.5-1.7-1-3.4-1-5" />
    <path d="M3 11c.4-1.6 1.1-3 2-4.3" />
  </svg>
)
